import React from "react";
import { Grid, Box } from "@mui/material";
import "assets/scss/styles.scss";

const ShimmerCard = () => (
  <Box className="shimmer-card-wrapper">
    <Box className="shimmer-card-header" />
    <Box className="shimmer-card-body">
      <Box className="shimmer-line short" />
      <Box className="shimmer-line medium" />
      <Box className="shimmer-line long" />
      <Box className="shimmer-button" />
    </Box>
  </Box>
);

const ShimmerDashboard = () => {
  return (
    <Grid container spacing={3} className="homespace">
      {[...Array(4)].map((_, index) => (
        <Grid item xs={12} sm={6} key={index} className="shimmer-box">
          <ShimmerCard />
        </Grid>
      ))}
    </Grid>
  );
};

export default ShimmerDashboard;
